import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from './components/Sidebar';
import { ClassificationBanner } from './components/dashboard/ClassificationBanner';
import { LiveAlertTicker } from './components/dashboard/LiveAlertTicker';
import { TopHeader } from './components/dashboard/TopHeader';
import { AppSidebar } from './components/dashboard/AppSidebar';
import { FooterStrip } from './components/dashboard/FooterStrip';
import { Toaster } from './components/Sonner';
import { Login } from './pages/Login';
import { ExecutiveDashboard } from './pages/ExecutiveDashboard';
import { DailyBrief } from './pages/DailyBrief';
import { AiAnalyst } from './pages/AiAnalyst';
import { HotIssue } from './pages/HotIssue';
import { Sentiment } from './pages/Sentiment';
import { ShadowNarrative } from './pages/ShadowNarrative';
import { PublicGrievance } from './pages/PublicGrievance';
import { ThreatIntel } from './pages/ThreatIntel';
import { DigitalEscort } from './pages/DigitalEscort';
import { VisitIntel } from './pages/VisitIntel';
import { Deepfake } from './pages/Deepfake';
import { ActorNetwork } from './pages/ActorNetwork';
import { BotDetection } from './pages/BotDetection';
import { ForeignInfluence } from './pages/ForeignInfluence';
import { Ipoleksosbudhankam } from './pages/Ipoleksosbudhankam';
import { Astagatra } from './pages/Astagatra';
import { Geospatial } from './pages/Geospatial';
import { PolicyImpact } from './pages/PolicyImpact';
import { ProgramWarRoom } from './pages/ProgramWarRoom';
import { CommandTasking } from './pages/CommandTasking';
import { ResponseRecommender } from './pages/ResponseRecommender';
import { LegalEvidence } from './pages/LegalEvidence';
import { PlatformReporting } from './pages/PlatformReporting';
import { CaseManagement } from './pages/CaseManagement';
import { Workbench } from './pages/Workbench';
import { Reports } from './pages/Reports';
import { MinistryMapping } from './pages/MinistryMapping';
import { NarrativeCalendar } from './pages/NarrativeCalendar';
import { AiConfiguration } from './pages/AiConfiguration';
import { WarRoom } from './pages/WarRoom';
import { HybridThreats } from './pages/HybridThreats';
import { CrisisSimulation } from './pages/CrisisSimulation';
import { PresidentialDigitalTwin } from './pages/PresidentialDigitalTwin';
import { Settings } from './pages/Settings';
import { Profile } from './pages/Profile';
import { Help } from './pages/Help';
import { ModulePlaceholder } from './pages/ModulePlaceholder';
function isAuthed() {
  try {
    return !!localStorage.getItem('gs_auth');
  } catch {
    return false;
  }
}
function ProtectedShell() {
  const loc = useLocation();
  if (!isAuthed()) return <Navigate to="/login" replace state={{
    from: loc.pathname
  }} data-id="element-0" />;
  return <div className="min-h-screen bg-background text-foreground selection:bg-primary/20" data-id="element-1">
      <SidebarProvider defaultOpen={true} data-id="element-2">
        <AppSidebar data-id="element-3" />
        <SidebarInset className="bg-background flex flex-col min-h-svh" data-id="element-4">
          <ClassificationBanner data-id="element-5" />
          <LiveAlertTicker data-id="element-6" />
          <TopHeader data-id="element-7" />
          <main className="flex-1 overflow-y-auto p-3 sm:p-4 lg:p-6 scrollbar-thin scrollbar-thumb-border scrollbar-track-transparent" data-id="element-8">
            <Outlet data-id="element-9" />
            <FooterStrip data-id="element-10" />
          </main>
        </SidebarInset>
      </SidebarProvider>
      <Toaster theme="light" position="bottom-right" richColors closeButton data-id="element-11" />
    </div>;
}
export function App() {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);
  return <BrowserRouter data-id="element-12">
      <Routes data-id="element-13">
        <Route path="/login" element={<Login data-id="element-15" />} data-id="element-14" />

        <Route path="/" element={<ProtectedShell data-id="element-17" />} data-id="element-16">
          <Route index element={<Navigate to="/dashboard" replace data-id="element-19" />} data-id="element-18" />
          <Route path="dashboard" element={<ExecutiveDashboard data-id="element-21" />} data-id="element-20" />
          <Route path="war-room" element={<WarRoom data-id="element-23" />} data-id="element-22" />

          <Route path="daily-brief" element={<DailyBrief data-id="element-25" />} data-id="element-24" />
          <Route path="ai-analyst" element={<AiAnalyst data-id="element-27" />} data-id="element-26" />

          <Route path="hot-issue" element={<HotIssue data-id="element-29" />} data-id="element-28" />
          <Route path="sentiment" element={<Sentiment data-id="element-31" />} data-id="element-30" />
          <Route path="shadow-narrative" element={<ShadowNarrative data-id="element-33" />} data-id="element-32" />
          <Route path="public-grievance" element={<PublicGrievance data-id="element-35" />} data-id="element-34" />

          <Route path="threat-intel" element={<ThreatIntel data-id="element-37" />} data-id="element-36" />
          <Route path="hybrid-threats" element={<HybridThreats data-id="element-39" />} data-id="element-38" />
          <Route path="digital-escort" element={<DigitalEscort data-id="element-41" />} data-id="element-40" />
          <Route path="visit-intel" element={<VisitIntel data-id="element-43" />} data-id="element-42" />
          <Route path="deepfake" element={<Deepfake data-id="element-45" />} data-id="element-44" />

          <Route path="actor-network" element={<ActorNetwork data-id="element-47" />} data-id="element-46" />
          <Route path="bot-detection" element={<BotDetection data-id="element-49" />} data-id="element-48" />
          <Route path="foreign-influence" element={<ForeignInfluence data-id="element-51" />} data-id="element-50" />

          <Route path="ipoleksosbudhankam" element={<Ipoleksosbudhankam data-id="element-53" />} data-id="element-52" />
          <Route path="astagatra" element={<Astagatra data-id="element-55" />} data-id="element-54" />
          <Route path="geospatial" element={<Geospatial data-id="element-57" />} data-id="element-56" />
          <Route path="policy-impact" element={<PolicyImpact data-id="element-59" />} data-id="element-58" />
          <Route path="program-war-room" element={<ProgramWarRoom data-id="element-61" />} data-id="element-60" />

          <Route path="command-tasking" element={<CommandTasking data-id="element-63" />} data-id="element-62" />
          <Route path="response-recommender" element={<ResponseRecommender data-id="element-65" />} data-id="element-64" />
          <Route path="crisis-simulation" element={<CrisisSimulation data-id="element-67" />} data-id="element-66" />

          <Route path="legal-evidence" element={<LegalEvidence data-id="element-69" />} data-id="element-68" />
          <Route path="platform-reporting" element={<PlatformReporting data-id="element-71" />} data-id="element-70" />
          <Route path="case-management" element={<CaseManagement data-id="element-73" />} data-id="element-72" />

          <Route path="workbench" element={<Workbench data-id="element-75" />} data-id="element-74" />
          <Route path="reports" element={<Reports data-id="element-77" />} data-id="element-76" />
          <Route path="ministry-mapping" element={<MinistryMapping data-id="element-79" />} data-id="element-78" />
          <Route path="narrative-calendar" element={<NarrativeCalendar data-id="element-81" />} data-id="element-80" />
          <Route path="ai-config" element={<AiConfiguration data-id="element-83" />} data-id="element-82" />
          <Route path="digital-twin" element={<PresidentialDigitalTwin data-id="element-85" />} data-id="element-84" />

          <Route path="settings" element={<Settings data-id="element-87" />} data-id="element-86" />
          <Route path="profile" element={<Profile data-id="element-89" />} data-id="element-88" />
          <Route path="help" element={<Help data-id="element-91" />} data-id="element-90" />

          <Route path="*" element={<ModulePlaceholder title="404 Not Found" description="Halaman tidak ditemukan." data-id="element-93" />} data-id="element-92" />
        </Route>
      </Routes>
    </BrowserRouter>;
}